import { Link, useLocation } from 'react-router-dom';

const NavIcon = ({ src, active, className }) => {
  const color = active ? '#26a8df' : '#7a7a7a';
  return (
    <span
      aria-hidden="true"
      className={className}
      style={{
        width: 28,
        height: 28,
        display: 'block',
        backgroundColor: color,
        WebkitMaskImage: `url(${src})`,
        WebkitMaskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        WebkitMaskSize: 'contain',
        maskImage: `url(${src})`,
        maskRepeat: 'no-repeat',
        maskPosition: 'center',
        maskSize: 'contain'
      }}
    />
  );
};

const isActivePath = (pathname, href) => {
  if (!href || href === '#') return false;
  if (href === '/' || href === '/prediction') {
    return pathname === '/' || pathname === '/prediction';
  }
  return pathname === href;
};

const NavBar = () => {
  const location = useLocation();
  const pathname = location.pathname;

  const items = [
    { key: 'prediction', label: 'Dự đoán', to: '/', iconSrc: '/assets/images/nav/home.png' },
    {
      key: 'schedule',
      label: 'Lịch thi đấu',
      to: '/match',
      iconSrc: '/assets/images/nav/match.png'
    },
    { key: 'rule', label: 'Thể lệ', to: '/rule', iconSrc: '/assets/images/nav/thele.png' },
    { key: 'history', label: 'Lịch sử', to: '/history', iconSrc: '/assets/images/nav/lichsu.png' }
  ];

  return (
    <nav
      aria-label="Bottom navigation"
      className="md:hidden rounded-full fixed left-1/2 bottom-0 -translate-x-1/2 z-50"
      style={{
        width: '418.75px',
        maxWidth: 'calc(100vw - 16px)',
        boxShadow: '0px -2.233px 11.167px 0px rgba(56,101,178,0.4)',
        paddingBottom: 'env(safe-area-inset-bottom)'
      }}
    >
      <div
        className="relative h-[67px] rounded-tl-[33px] rounded-tr-[33px]"
        style={{
          background: 'var(--color-header-nav-bg)',
          border: '0.5px solid var(--color-header-nav-border)',
          boxShadow: 'var(--shadow-header-nav)'
        }}
      >
        <div
          className="absolute inset-0 pointer-events-none rounded-tl-[33px] rounded-tr-[33px]"
          style={{ boxShadow: 'var(--shadow-header-nav-inset)' }}
        />

        <div className="h-full flex items-center justify-center gap-[28px] md:gap-[32px]">
          {items.map((item) => {
            const active = isActivePath(pathname, item.to);
            const color = active ? '#26a8df' : '#7a7a7a';

            const content = (
              <div className="h-[67px] w-[60px] flex flex-col items-center justify-center">
                <NavIcon src={item.iconSrc} active={active} className="" />
                <div className="mt-1 flex items-center justify-center">
                  <span
                    className="font-semibold text-[11.167px] leading-[14.517px] text-center"
                    style={{ color }}
                  >
                    {item.label}
                  </span>
                </div>
              </div>
            );

            if (item.disabled || item.to === '#') {
              return (
                <button
                  key={item.key}
                  type="button"
                  aria-disabled="true"
                  className="bg-transparent border-0 p-0"
                  style={{ color, cursor: 'default' }}
                >
                  {content}
                </button>
              );
            }

            return (
              <Link
                key={item.key}
                to={item.to}
                aria-current={active ? 'page' : undefined}
                className="block"
                style={{ color }}
              >
                {content}
              </Link>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
